import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9a9 3 0 1 0 18 0a9 3 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M3 9a9 9 0 0 0 18 0","key":"svg-1"}]]

const IconHemisphere = createReactComponent('outline', 'hemisphere', 'Hemisphere', __iconNode);

export default IconHemisphere;